import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import EntityForm from "@/admin/components/EntityForm";
import { fetchEntityQueryOptions } from "@/admin/services";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/entity/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Entities", { ns: "core.shared" }),
      crumb: [
        {
          label: context.t("Edit Base Entity", { ns: "core.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchEntityQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();
  const { t } = useTranslation("core.shared");
  return (
    <Container
      title={t("Edit Base Entity")}
      description={t("Manage, create and edit base entities")}
      className="flex h-full flex-col"
    >
      <EntityForm id={id} />
    </Container>
  );
}
